import CallAPI from "../../utility/functions/getData";
import {
  setAlertWithTitle,
  setSpinnerLoading,
} from "../../utility/Redux/modal";
import deleteWholeDatabase from "../../utility/functions/deleteWholeDatabase";
import dataToLocal from "../../utility/component/dataToLocal";

export const GetItemWisePurchaseSummary = (
  data,
  token,
  dispatch,
  setPurchaseList,
  setFullItemWiseReport,setTotalPages,setCurrentPage
) => {
  dispatch(setSpinnerLoading("Loading..."));
  if (data.SECTION_NAME === "") {
    deleteWholeDatabase("section_wise_offer_report");
  }
  CallAPI(
    "/api/offerMaster/listOffer",
    data,
    token,
    (e) => {
      if (!e.data.error) {
        const res = e.data.response;
        console.log(e)
        setTotalPages(e.data.totalPages)
        setCurrentPage(e.data.currentPage)
        if (res[0]) {
          setPurchaseList(res);
          if (data.SECTION_NAME === "") {
            dataToLocal("section_wise_offer_report", res, [
              {
                ...data,
                ICODE: 1,
              },
            ]);
            setFullItemWiseReport(res);
          }
        } else {
          setPurchaseList([]);

          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: "No data found",
            })
          );
        }
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Something Went Wrong.",
          })
        );
      }
    },
    dispatch,
    () => {
      dispatch(setSpinnerLoading(false));
    }
  );
};

export const GetSectionWisePurchaseSummary = (
  data,
  token,
  dispatch,
  setSummaryList
) => {
  deleteWholeDatabase("sectionWiseOffer");
  CallAPI(
    "/api/offerMaster/listOfferSectionWise",
    data,
    token,
    (e) => {
      console.log(e)
      if (!e.data.error) {
        if (e.data.response) {
          dataToLocal("sectionWiseOffer", e.data.response, [
            {
              ...data,
              ICODE: 1,
            },
          ]);
        }
        setSummaryList(e.data.response);
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Something Went Wrong.",
          })
        );
      }
    },
    dispatch
  );
};
